var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { combineReducers } from './combine-reducers';
export var removeAsyncReducer = function (_a) {
    var store = _a.store, name = _a.name;
    var asyncReducers = store.asyncReducers;
    var rootReducers = store.rootReducers;
    var wasReducerInjected = Boolean(asyncReducers[name]);
    var wasRootReducerInjected = Boolean(rootReducers[name]);
    if (!wasReducerInjected || wasRootReducerInjected) {
        return;
    }
    delete asyncReducers[name];
    var _b = store.getState(), _c = name, reducerToDelete = _b[_c], prevState = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]); // eslint-disable-line
    // define new reducer
    var newReducer = combineReducers(__assign(__assign(__assign({}, prevState), asyncReducers), rootReducers));
    // log to the devtools
    store.dispatch({
        type: '@REDUX-CORE-MODULES REMOVE REDUCER',
        payload: {
            name: name,
        },
    });
    // inject reducer
    store.replaceReducer(newReducer);
};
